export type TargetIndustryHref =
  | "/solutions/e-commerce"
  | "/solutions/education"
  | "/solutions/science"
  | "/solutions/local";

export type TargetIndustryItem = {
  title: string;
  description: string;
  href: TargetIndustryHref;
  /** md+：6 列栅格占位（上行 3+3，下行 3+3） */
  spanClass: string;
  imageSrc: string;
  imageAlt: string;
};

/**
 * 配图来源：Unsplash（站内本地化副本，见 /public/images/target-industries/）
 */
export const targetIndustries: TargetIndustryItem[] = [
  {
    title: "零售与消费",
    description:
      "新客接待 + 智能选品推荐 + 大促期间万单无压力。",
    href: "/solutions/e-commerce",
    spanClass: "md:col-span-3",
    imageSrc: "/images/target-industries/ecommerce.png",
    imageAlt: "零售卖场与陈列：现代电商与门店购物体验",
  },
  {
    title: "在线教育",
    description:
      "课程咨询 + 试听邀约 + 续费 / 转介绍闭环",
    href: "/solutions/education",
    spanClass: "md:col-span-3",
    imageSrc: "/images/target-industries/education.png",
    imageAlt: "课堂与学习空间：专注、有序的教学氛围",
  },
  {
    title: "金融与科技",
    description:
      "产品咨询 + 合规问答 + 高客单价线索精准培育",
    href: "/solutions/science",
    spanClass: "md:col-span-3",
    imageSrc: "/images/target-industries/tech.png",
    imageAlt: "团队协作与办公场景：企服与数字化协作",
  },
  {
    title: "本地生活",
    description:
      "门店导流 + 团购核销 + 高频复购与口碑裂变",
    href: "/solutions/local",
    spanClass: "md:col-span-3",
    imageSrc: "/images/target-industries/local.png",
    imageAlt: "餐饮与本地门店空间：到店体验与氛围",
  },
];
